import { render } from "./BuildingTypeEdit.vue?vue&type=template&id=6c98583e&scoped=true"
import script from "./BuildingTypeEdit.vue?vue&type=script&lang=js"
export * from "./BuildingTypeEdit.vue?vue&type=script&lang=js"

import "./BuildingTypeEdit.vue?vue&type=style&index=0&id=6c98583e&scoped=true&lang=css"

import exportComponent from "/Users/shohei/workspace/soei_project/measure_rep_mng/vue3_measure_rep_mng/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c98583e"]])

export default __exports__